import addListOfPermissionSlugs from "../utils/add-list-of-permission-slugs";

export const isFetching = state => state.permissions.groups.fetching;
export const permissionProfiles = state =>
  state.permissions.profiles.profiles.map(addListOfPermissionSlugs);
